export const JSONPATH_JOIN_CHAR = '.';
export const SCHEMA_TYPE = [
    { label: '字符串', value: 'string' },
    { label: '数字', value: 'number' },
    { label: '日期', value: 'date' },
    { label: '数组', value: 'array' },
    { label: '对象', value: 'object' },
    { label: '布尔值', value: 'boolean' },
    { label: '整数', value: 'integer' },
    { label: '实体引用', value: 'ref' },
];
export const defaultSchema = {
    string: {
        type: 'string',
    },
    number: {
        type: 'number',
    },
    date: {
        type: 'date',
    },
    array: {
        type: 'array',
        items: {
            type: 'string',
        },
    },
    object: {
        type: 'object',
        properties: {},
    },
    boolean: {
        type: 'boolean',
    },
    integer: {
        type: 'integer',
    },
    ref: {
        type: 'ref',
    },
};
